import React, { useState, useEffect, useRef, useMemo } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton } from '@mui/material';

export default function ScrollDialog(props) {
  const showCloseIcon = useMemo(() => props.showCloseIcon || false,[props.showCloseIcon]);
  const disableDialogActions = useMemo(() => props.disableDialogActions || false,[props.disableDialogActions]);
  const [open, setOpen] = useState(false);
  const [scroll] = useState('paper');

  const handleClose = () => {
    // if(props.onModalClose){
      props.onModalClose();
    // }
    setOpen(false);
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    if(props.open !== open){
      setOpen(props.open);
    }
  }, [props.open, setOpen, open]);

  return (
    <Dialog
      fullWidth
      maxWidth={ props.maxWidth || "sm"}
      open={open}
      onClose={handleClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        {props.title || ''}
       {showCloseIcon ? (<IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>):null}
      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        {/* <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        > */}
          {props.children}
        {/* </DialogContentText> */}
      </DialogContent>
      {disableDialogActions === true ? null :(<DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>)}
    </Dialog>
  );
}
